import { isString, sanitizeStringForUrl } from '@grandvisionhq/utils';
import '@swc/helpers';
import '@bloomreach/spa-sdk';
import { getUrl } from '../../../../utils/get-url.js';
import '@grandvisionhq/search';
import 'jsonpointer';
import '@grandvisionhq/common';
import '../../../../utils/http-client.js';

function createGraphSubCategoryBreadcrumb(categoryRoute, brand, page, variant) {
    var ref;
    let subCategoryProperty = brand;
    if (variant.variantType === 'accessories') {
        subCategoryProperty = variant.accessoryType;
    }
    if (variant.variantType === 'contact-lens' && variant.replacementFrequency) {
        subCategoryProperty = variant.replacementFrequency;
    }
    var ref1;
    // Get the path of the route (in BR preview you also get some querystring that we don't need to create the subcategory link)
    const categoryRoutePath = (ref1 = (ref = categoryRoute === null || categoryRoute === void 0 ? void 0 : categoryRoute.split('?')) === null || ref === void 0 ? void 0 : ref[0]) !== null && ref1 !== void 0 ? ref1 : '';
    return isString(subCategoryProperty) && subCategoryProperty !== '' ? {
        name: subCategoryProperty,
        url: getUrl(`${categoryRoutePath}/${encodeURIComponent(sanitizeStringForUrl(subCategoryProperty))}`, page)
    } : null;
}

export { createGraphSubCategoryBreadcrumb };
//# sourceMappingURL=create-graph-subcategory-breadcrumb.js.map
